import { BFocalImage, Image, Preview } from './styles'

BFocalImage.Image = Image
BFocalImage.Preview = Preview

export default BFocalImage
